import {
  GTM_CLICK_MAP_PIN_LISTING,
  GTM_CLICK_SEARCH_PAGE_SATELLITE_VIEW,
  GTM_CLICK_SEARCH_PAGE_STREET_VIEW,
  GTM_SEARCH_PAGE_VIEW,
  GTM_SEARCH_PAGE_MLML_VIEW,
  GTM_SIMPLE_CHAT_VIEW,
  GTM_SIMPLE_CHAT_CLOSE_LIST,
  GTM_SIMPLE_CHAT_CHOOSE_BATHROOMS,
  GTM_SIMPLE_CHAT_CHOOSE_BEDROOMS,
  GTM_SIMPLE_CHAT_CHOOSE_BUDGET,
  GTM_SIMPLE_CHAT_CLEAR_SEARCH,
  GTM_SIMPLE_CHAT_CLICK_ADD,
  GTM_SIMPLE_CHAT_CLOSE_CHAT,
  GTM_SIMPLE_CHAT_REMOVE_BATHROOMS,
  GTM_SIMPLE_CHAT_REMOVE_BEDROOMS,
  GTM_SIMPLE_CHAT_REMOVE_BUDGET,
  GTM_SIMPLE_CHAT_SAVE_PROPERTY_TYPE,
  GTM_SIMPLE_CHAT_SWITCH_TO_REGULAR_CHAT,
  GTM_CLICK_MAP_PAGE_SIDEBAR_CARD,
  GTM_CLICK_MAP_PAGE_PIN,
  GTM_CLICK_MAP_PAGE_LISTING_POPOVER,
  GTM_MAP_PAGE_FAVOURITE_PROPERTY,
  GTM_CLICK_SEARCH_MAP_ZOOM_IN,
  GTM_CLICK_SEARCH_MAP_ZOOM_OUT,
  GTM_CLICK_SEARCH_MAP_CONTROLS_FILTER,
  GTM_CLICK_SEARCH_MAP_MY_LOCATION,
} from 'constants/events';
import { AnalyticsController } from 'analytics/analytics-controller';

export const TrackPageView = () => AnalyticsController.trackEvent(GTM_SEARCH_PAGE_VIEW);
export const TrackMLMLPageView = (showsMLML: boolean) => {
  if (showsMLML) {
    AnalyticsController.trackEvent(GTM_SEARCH_PAGE_MLML_VIEW);
  }
};
export const TrackMoreButtonClick = () => AnalyticsController.trackEvent('UiSrchQfMoreButClk');
export const TrackSaveSearchButtonClick = () => AnalyticsController.trackEvent('UiSrchQfSaveButClk');
export const TrackMapPinListingClicked = () => {
  AnalyticsController.trackEvent(GTM_CLICK_MAP_PIN_LISTING);
  AnalyticsController.trackEvent(GTM_CLICK_MAP_PAGE_PIN);
  AnalyticsController.trackEvent('UiSrcMapCardClusterClk');
};
export const TrackMapPinListingNoModalClicked = () => {
  AnalyticsController.trackEvent('Xp_UiAddresspView');
  AnalyticsController.trackEvent(GTM_CLICK_MAP_PIN_LISTING);
};
export const TrackSatelliteViewClicked = () => AnalyticsController.trackEvent(GTM_CLICK_SEARCH_PAGE_SATELLITE_VIEW);
export const TrackStreetViewClicked = () => AnalyticsController.trackEvent(GTM_CLICK_SEARCH_PAGE_STREET_VIEW);
export const TrackSimpleChatView = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_VIEW);
export const TrackSimpleChatSavePropertyType = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_SAVE_PROPERTY_TYPE);
export const TrackSimpleChatChooseBedrooms = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_CHOOSE_BEDROOMS);
export const TrackSimpleChatChooseBathrooms = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_CHOOSE_BATHROOMS);
export const TrackSimpleChatChooseBudget = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_CHOOSE_BUDGET);
export const TrackSimpleChatClearSearch = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_CLEAR_SEARCH);
export const TrackSimpleChatClickAdd = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_CLICK_ADD);
export const TrackSimpleChatRemoveBedrooms = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_REMOVE_BEDROOMS);
export const TrackSimpleChatRemoveBathrooms = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_REMOVE_BATHROOMS);
export const TrackSimpleChatRemoveBudget = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_REMOVE_BUDGET);
export const TrackSimpleChatSwitchToRegularChat = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_SWITCH_TO_REGULAR_CHAT);
export const TrackSimpleChatCloseChat = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_CLOSE_CHAT);
export const TrackSimpleChatCloseList = () => AnalyticsController.trackEvent(GTM_SIMPLE_CHAT_CLOSE_LIST);

export const TrackMapListingCardClicked = () => AnalyticsController.trackEvent(GTM_CLICK_MAP_PAGE_SIDEBAR_CARD);
export const TrackMapListingPopoverCardClicked = () => AnalyticsController.trackEvent(GTM_CLICK_MAP_PAGE_LISTING_POPOVER);
export const TrackMapListingFavouriteClicked = () => AnalyticsController.trackEvent(GTM_MAP_PAGE_FAVOURITE_PROPERTY);

export const TrackMapControlsZoomInClick = () => AnalyticsController.trackEvent(GTM_CLICK_SEARCH_MAP_ZOOM_IN);
export const TrackMapControlsZoomOutClick = () => AnalyticsController.trackEvent(GTM_CLICK_SEARCH_MAP_ZOOM_OUT);
export const TrackMapControlsFilterClick = () => AnalyticsController.trackEvent(GTM_CLICK_SEARCH_MAP_CONTROLS_FILTER);
export const TrackMapControlsMyLocationClick = () => AnalyticsController.trackEvent(GTM_CLICK_SEARCH_MAP_MY_LOCATION);